<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="headphones"/>
          {{ $t('systemRecording') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
            <button @click="create" class="btn btn-success mr-1 mb-1">
              <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
            </button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <p class="pull-left" v-if="itemCount">{{ $t('found', [itemCount]) }}</p>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" v-model="filterFormModel.page"
                      :total-rows="itemCount" :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('name') }}</div>
            <div class="col-lg-3">{{ $t('key') }}</div>
            <div class="col-lg-3"></div>
            <div class="col-lg-3"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <b class="c-smart-table__label">{{ $t('name') }}: </b>
              <span>{{ item.name }}</span>
            </div>
            <div class="col-lg-3">
              <b class="c-smart-table__label">{{ $t('key') }}: </b>
              <span>{{ item.key }}</span>
            </div>
            <div class="col-lg-3">
              <audio v-if="item.hash" controls>
                <source :src="item.hash" type="audio/mp3">
              </audio>
            </div>
            <div class="col-lg-3">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button class="btn btn-sm btn-info mr-1" @click="update(item._id)">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1" v-if="['owner', 'admin'].includes($store.state.user.role)">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <p class="pull-left">{{ $t('found', [itemCount]) }}</p>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" v-model="filterFormModel.page"
                      :total-rows="itemCount" :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
      </div>
      <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
        <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
        <form-input :disabled="formModel._id" :label="$t('key')" :model="formModel" attribute="key"
                    :errors="formErrors"></form-input>
        <form-file :label="$t('file')" service="/upload/recording" :model="formModel" attribute="file"
                   :placeholder="$t('filePlaceholder')" :errors="formErrors" accept="audio/wav"></form-file>
        <audio v-if="formModel.hash" controls>
          <source :src="formModel.hash" type="audio/mp3">
        </audio>
      </b-modal>
    </div>
  </main>
</template>
<script>
import list from '../../mixins/List';
import crud from '../../mixins/CRUD';
import utils from '../../utils';


export default {
  components: {},
  mixins: [list, crud, utils],
  data: function () {
    return {
      service: '/system-recording',
      autoLoad: true,
      defaultFormModel: {
        name: '',
        key: ''
      }
    }
  },
  watch: {
    "formModel.name": {
      handler(val) {
        if (!this.formModel.id) {
          this.formModel.key = this.createAlias(val);
        }
      }
    },
  },
  mounted() {
  },
  i18n: {
    messages: {
      en: {
        systemRecording: 'System recording',
        name: 'Recording name',
        file: 'Select file',
        filePlaceholder: 'WAV file, sample rate 8000hz, max size: 10mb',
        key: 'Key'
      },
      vi: {
        systemRecording: 'File ghi âm hệ thống',
        name: 'Tên file ghi âm',
        file: 'Chọn file',
        filePlaceholder: 'Định dạng wav, sample rate 8000hz, tối đa 10mb',
        key: 'Mã'
      }
    }
  }
}
</script>